import GeoTrace from './geo-script.js';

/**
 * class NewsletterEnrollment
 */
class NewsletterEnrollment extends elementorModules.frontend.handlers.Base {

	/**
	 * On Init
	 *
	 * Runs when the widget is loaded and initialized in the frontend.
	 */
	onInit() {
		document.addEventListener( 'strattic-form-submit', ( event ) => {
			const formId = event.detail.form.id;

			if (  ! formId.includes('elementor_newsletter_subscribe') ) {
				return;
			}
			this.publishEvent(event.detail.form);
		});
	}

	async publishEvent(form) {
		const emailFieldId = form.id.replace('elementor_newsletter_subscribe', 'form-field-email');

		const emailData = document.getElementById( emailFieldId ).value;

		if ( ! emailData ) {
			return;
		}

		const attributes = this.getElementSettings( 'additional_attributes' );
		const ip = await new GeoTrace().getIpAddress();

		const eventData = {
			'email': emailData,
			'source': document.referrer,
			'context': form.name ?? '',
			'enroll_date': this.getUnixTimestamp(),
			'attributes': this.getAttributes( attributes ),
			'ip': ip
		};
		const eventResponse = await this.subscribe( eventData );
		if ( ! eventResponse.success ) {
			return;
		}

	}

	async subscribe( data ) {
		return await fetch( window.newsletterEnrollmentData?.cfWorkerUrl, {
			method: 'POST',
			timeout: 5,
			body: JSON.stringify( data )
		} );
	}

	/**
	 * getUnixTimestamp
	 * @return {number}
	 */
	getUnixTimestamp() {
		return Math.floor( Date.now() / 1000 )
	}

	/**
	 * getAttributes
	 * @param attributes
	 */
	getAttributes( attributes ) {
		const data = {};
		for ( let attribute of attributes ) {
			data[ attribute[ 'attr_key' ] ] = attribute[ 'attr_value' ];
		}
		return data;
	}

}

/**
 * Register JS Handler for the Test Widget
 *
 * When Elementor frontend was initiated, and the widget is ready, register the widet
 * JS handler.
 */
window.addEventListener( 'elementor/frontend/init', () => {
	const addHandler = ( $element ) => {
		elementorFrontend.elementsHandler.addHandler( NewsletterEnrollment, { $element } );
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/form.default', addHandler );
} );
